var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F6F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 16.7333V24.5827H19.6667L20.3334 23.916C20.6667 23.5827 20.6667 23.0827 20.3334 22.7493C20.0001 22.416 19.5001 22.416 19.1667 22.7493L17.0834 24.8327C16.7501 25.166 16.7501 25.666 17.0834 25.9994L19.1667 28.0827C19.3334 28.2493 19.5001 28.3327 19.7501 28.3327C20.0001 28.3327 20.1667 28.2493 20.3334 28.0827C20.6667 27.7493 20.6667 27.2493 20.3334 26.916L19.6667 26.2493H27.5001C28.0001 26.2493 28.3334 25.916 28.3334 25.416V15.0175L26.6667 16.7333Z",
    fill: "#1B2430"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 23.3393V15.416H19.8334L19.1667 16.0827C19.0001 16.2493 18.9167 16.416 18.9167 16.666C18.9167 17.166 19.2501 17.4993 19.7501 17.4993C20.0001 17.4993 20.1667 17.416 20.3334 17.2493L22.4167 15.166C22.7501 14.8327 22.7501 14.3327 22.4167 13.9993L20.3334 11.916C20.0001 11.5827 19.5001 11.5827 19.1667 11.916C18.8334 12.2493 18.8334 12.7493 19.1667 13.0827L19.8334 13.7493H12.5001C12.0001 13.7493 11.6667 14.0827 11.6667 14.5827L11.6667 24.9981L13.3334 23.3393Z",
    fill: "#1B2430"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0834 11.916C28.4167 12.2493 28.4167 12.7493 28.0834 13.0827L13.0834 28.0827C12.9167 28.2493 12.7501 28.3327 12.5001 28.3327C12.0001 28.3327 11.6667 27.9993 11.6667 27.4993C11.6667 27.2493 11.7501 27.0827 11.9167 26.916L26.9167 11.916C27.2501 11.5827 27.7501 11.5827 28.0834 11.916Z",
    fill: "#1B2430"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRepeat);
export default __webpack_public_path__ + "static/media/NoRepeat.4958b52f.svg";
export { ForwardRef as ReactComponent };